import { ProColumns } from '@ant-design/pro-table/lib/typing';
import { trpc } from '@tencent/tpro_rmonitor_web_server_traffic';
import { get } from 'lodash-es';
import React, { useContext, useState } from 'react';
import * as uuid from 'uuid';
import { BASE_NAME, toSearchStr } from '@/infrastructure/history';
import { PageSetting } from '@/infrastructure/page-sort';
import { getProductId } from '@/infrastructure/product-info';
import { formatByte2Mb } from '@/infrastructure/utils/digit';
import { formatTimestamp } from '@/infrastructure/utils/timestamp';
import { IssueList } from '@/presentation/components/issue-list';
import style from '@/presentation/components/issue-table/index.module.scss';
import { renderTrafficExceptionType } from '@/presentation/pages/traffic/issues/detail/case/content/error-detail';
import { NetExceptionListContext } from '@/presentation/pages/traffic/issues/list/context';
import { Zone } from '@/proto/field';
import { FieldList } from '@/proto/token';
import { trafficService } from '@/service/traffic';
import { WithTypeCast } from '@raft/utils';

type IReportInfo = WithTypeCast<trpc.rmonitor.web_server.GetReportListRsp.IReportInfo>;

export const Attribution = ({ fetch, token }: {
  token: string;
  fetch: boolean;
  fields?: FieldList;
}) => {
  const { pageId } = useContext(NetExceptionListContext);


  const renderTimestamp = (lastReportTime: string) => <div style={{
    width: '100px',
    textAlign: 'left',
    color: undefined,
  }}>
    {formatTimestamp(lastReportTime, 'YYYY-MM-DD HH:mm:ss').replace(' ', '\n')}
  </div>;

  const trafficRender = (value: number) => formatByte2Mb(value);

  const columns: ProColumns<IReportInfo>[] = [
    {
      dataIndex: 'qimei',
      title: '设备ID',
      fixed: 'left',
      width: 130,
      render: (value, record) => rowClick(value, record),
      hideInSetting: true,
    },
    {
      dataIndex: 'reportTime',
      title: '采集时间',
      width: 120,
      sorter: true,
      render: (
        _: unknown,
        record: IReportInfo,
      ) => rowClick(renderTimestamp(record.reportTime ?? ''), record),
    },
    {
      dataIndex: 'trafficSize',
      title: '异常流量',
      width: 120,
      sorter: true,
      defaultSortOrder: 'descend',
      render: (_: unknown, record: IReportInfo) => rowClick(trafficRender(get(record, 'exceptionParentTrafficSize', 0)), record),
    },
    {
      dataIndex: 'exceptionType',
      title: '异常类型',
      render: (
        _: unknown,
        record: IReportInfo,
      ) => rowClick(renderTrafficExceptionType(record.exceptionType ?? 0), record),

      width: 150,
    },
    {
      dataIndex: 'appVersion',
      title: '应用版本',
      width: 120,
      render: (value, record) => rowClick(value, record),
    },
    {
      dataIndex: 'osVersion',
      title: '系统版本',
      width: 120,
      render: (value, record) => rowClick(value, record),
    },
    {
      dataIndex: 'model',
      title: '机型',
      width: 120,
      render: (value, record) => rowClick(value, record),
    },
  ];
  const rowClick = (txt: string|number|React.ReactNode, record: IReportInfo) => {
    const toDetail = () => {
      const queryStr = toSearchStr({ cId: record.clientIdentify });
      const rul = `${location.origin}${BASE_NAME}/traffic/issues/case?${queryStr}`;
      window.open(rul, '_blank');
    };
    return <div className={style.caseRowClick} onClick={toDetail}>{txt}</div>;
  };

  const [total, setTotal] = useState(0);
  const [data, setData] = useState<any>([]);

  const loadData = async (pageSetting: PageSetting) => {
    if (!token) {
      return;
    }
    const defaultSortField = 'traffic_size';
    const defaultSortType = 'DESC';
    const params = {
      productId: getProductId(),
      token,
      ...pageSetting,
      sortField: pageSetting.sortField && pageSetting.sortType ? pageSetting.sortField : defaultSortField,
      sortType: pageSetting.sortType || defaultSortType,
    };
    const data = await trafficService.getReportList(params);
    setTotal(data?.docCount);
    setData(data?.reportInfo?.map?.(item => ({ ...item, key: uuid.v4() })) || []);
  };

  return (
    <IssueList<IReportInfo>
      token={token}
      className={style.netTable}
      pgId={pageId}
      name={''}
      xlsxName={'流量-异常分析-异常个例'}
      info={''}
      rowKey={'key'}
      data={data}
      total={total}
      type={Zone.Net}
      formatColumn={() => columns}
      loadData={loadData}
      getIssueUrl={() => ''}
      batchMode={{ tapd: false, export: true, cancel: false }}
      fetch={fetch}
    />
  );
};
